// 导入必要的包

import { Progress } from 'element-ui' //前端的样式组件
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2' //此插件可以使得前端页面能够给复制
import './utils/rem' //用来调整窗口大小的
import VueSocketIO from 'vue-socket.io'
import socketIO from 'socket.io-client'
import i18n from './lang';

// let ip = 'http://127.0.0.1:5000/ws'
// let ip = 'http://42.193.244.165:5000/ws'
let ip = 'https://www.sensevib.com/ws'

Vue.use(new VueSocketIO({
    debug: true,
    connection: socketIO(ip , {
        autoConnect:false,
        transports:['websocket'],
        reconnectionAttempts: 1,
        reconnectionDelay: 60000,
        auth: {
            token: `Bearer ${localStorage.getItem('jwt-token')}`
        }
    })
}))

const setup = {
    async install (Vue) {
        Vue.use(ElementUI)
        Vue.prototype.$echarts = echarts
    }
}

Vue.use(VueClipboard)
Vue.use(setup)
Vue.use(Progress)


//阻止示显示生产模式的消息
Vue.config.productionTip = false

Vue.config.silent = true;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js